// Complete updated script for b2b-account-modal.js

document.addEventListener('DOMContentLoaded', function() {
  console.log('B2B Account Manager script loaded');

const i18n = 
{ de: { title: 'Anmelden', 
  existingTitle: 'Bestehende Kunden', 
  existingText: 'Sie haben bereits ein Konto? Melden Sie sich an, um auf Ihr Kundenkonto zuzugreifen.', 
  login: 'Anmelden', 
  newTitle: 'Neuer Geschäftskunde?', 
  newText1: 'Dieser Shop ist ausschließlich für Geschäftskunden (B2B).', 
  newText2: 'Bitte registrieren Sie Ihr Unternehmen, um zu starten.', 
  register: 'Unternehmen registrieren' },

en: { title: 'Account Access', 
  existingTitle: 'Existing Customers', 
  existingText: 'Already have an account? Login to access your account dashboard.', 
  login: 'Login', 
  newTitle: 'New Business Customer?', 
  newText1: 'This store is exclusively for business customers (B2B).', 
  newText2: 'Please register your business to get started.', 
  register: 'Register Your Business' }, 

fr: { title: 'Accès au compte', 
  existingTitle: 'Clients existants', 
  existingText: 'Vous avez déjà un compte ? Connectez-vous pour accéder à votre compte client.', 
  login: 'Se connecter', 
  newTitle: 'Nouveau client professionnel ?', 
  newText1: 'Cette boutique est exclusivement réservée aux clients professionnels (B2B).', 
  newText2: 'Veuillez enregistrer votre entreprise pour commencer.', 
  register: 'Enregistrer votre entreprise' }, 

it: { title: 'Accesso account', 
  existingTitle: 'Clienti esistenti', 
  existingText: 'Hai già un account? Accedi per visualizzare il tuo account cliente.', 
  login: 'Accedi', 
  newTitle: 'Nuovo cliente business?', 
  newText1: 'Questo negozio è riservato esclusivamente ai clienti business (B2B).', 
  newText2: 'Registra la tua azienda per iniziare.', 
  register: 'Registra la tua azienda' }, 

es: { title: 'Acceso a la cuenta', 
  existingTitle: 'Clientes existentes', 
  existingText: '¿Ya tiene una cuenta? Inicie sesión para acceder a su cuenta.', 
  login: 'Iniciar sesión', 
  newTitle: '¿Nuevo cliente empresarial?', 
  newText1: 'Esta tienda es exclusivamente para clientes empresariales (B2B).', 
  newText2: 'Registre su empresa para comenzar.', 
  register: 'Registrar su empresa' } 
  
};
  const lang = document.documentElement.lang?.split('-')[0] || 'en';
  const t = i18n[lang] || i18n.en;

    function localizedPath(path) {
    const root =
      (window.Shopify && Shopify.routes && Shopify.routes.root)
        ? Shopify.routes.root
        : (document.documentElement.getAttribute('lang') ? `/${document.documentElement.getAttribute('lang')}/` : '/');

    const cleanRoot = root.endsWith('/') ? root : `${root}/`;
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return cleanRoot + cleanPath;
  }
  
  // Function to show the modal
  function showLoginOptionsModal() {
    // Create modal container
    const modal = document.createElement('div');
    modal.className = 'login-options-modal';
    
    // Modal content with improved structure
modal.innerHTML = `
  <div class="login-modal-content">
    <span class="login-modal-close">&times;</span>
    <h2>${t.title}</h2>
    
    <div class="login-options-container">
      <div class="login-option">
        <div class="login-option-content">
          <h3>${t.existingTitle}</h3>
          <p>${t.existingText}</p>
        </div>
        <button class="btn login-btn">${t.login}</button>
      </div>
      
      <div class="login-option">
        <div class="login-option-content">
          <h3>${t.newTitle}</h3>
          <p>${t.newText1}</p>
          <p>${t.newText2}</p>
        </div>
        <button class="btn register-btn">${t.register}</button>
      </div>
    </div>
  </div>
`;
    
    // Improved modal styles
    const modalStyles = `
      .login-options-modal {
        display: none;
        position: fixed;
        z-index: 9999;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        align-items: center;
        justify-content: center;
      }
      
      .login-modal-content {
        background-color: #fff;
        margin: auto;
        padding: 25px;
        border-radius: 8px;
        width: 90%;
        max-width: 800px;
        position: relative;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
      }
      
      .login-modal-close {
        position: absolute;
        top: 15px;
        right: 20px;
        font-size: 28px;
        font-weight: bold;
        cursor: pointer;
      }
      
      .login-options-container {
        display: flex;
        flex-wrap: wrap;
        gap: 1px;
        margin-top: 20px;
      }
      
      .login-option {
        flex: 1;
        min-width: 280px;
        padding: 20px;
        background-color: #f9f9f9;
        border-radius: 0px;
        border-left: 1px solid #555;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      
      .login-option-content {
        flex-grow: 1;
      }
      
      .btn {
        display: inline-block;
        padding: 10px 20px;
        background-color: #555;
        color: white;
        text-decoration: none;
        border-radius: 4px;
        margin-top: 15px;
        text-align: center;
        cursor: pointer;
        border: none;
        font-size: 16px;
        align-self: flex-start;
      }
      
      .register-btn {
        background-color: #4a8fe7;
      }
      
      @media (max-width: 767px) {
        .login-options-container {
          flex-direction: column;
        }
      }
    `;
    
    // Check if styles already exist
    if (!document.getElementById('b2b-modal-styles')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'b2b-modal-styles';
      styleEl.textContent = modalStyles;
      document.head.appendChild(styleEl);
    }
    
    // Add modal to body
    document.body.appendChild(modal);
    
    // Show modal
    setTimeout(() => {
      modal.style.display = 'flex';
    }, 10);
    
    // Close button functionality
    const closeBtn = modal.querySelector('.login-modal-close');
    closeBtn.addEventListener('click', function() {
      modal.style.display = 'none';
      setTimeout(() => {
        modal.remove();
      }, 300);
    });
    
    // Close when clicking outside the modal content
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
        setTimeout(() => {
          modal.remove();
        }, 300);
      }
    });
    
    // Login button click handler
    const loginBtn = modal.querySelector('.login-btn');
    loginBtn.addEventListener('click', function() {
      // Close modal first
      modal.style.display = 'none';
      setTimeout(() => {
        modal.remove();
        // Then redirect to login page
        window.location.href = localizedPath('/account/login');
      }, 100);
    });
    
    // Register button click handler
    const registerBtn = modal.querySelector('.register-btn');
    registerBtn.addEventListener('click', function() {
      // Close modal first
      modal.style.display = 'none';
      setTimeout(() => {
        modal.remove();
        // Then redirect to registration page
        window.location.href = localizedPath('/pages/b2b-registration');
      }, 100);
    });
  }
  
  // Make the function globally available
  window.showB2BLoginModal = showLoginOptionsModal;
  
  // Only for non-logged in users
  if (!window.shopifyCustomerLoggedIn) {
    // Intercept clicks on account links
    document.addEventListener('click', function(e) {
      const target = e.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');
        if (href && (
            href.includes('/account/login') || 
            href.includes('/account') && !href.includes('register')
        )) {
          console.log('Intercepted click on account link:', href);
          e.preventDefault();
          showLoginOptionsModal();
        }
      }
    }, true);
  }
});